import React from 'react';
import { Link } from 'react-router-dom';

// Shared footer — used on marketing/informational pages (Landing, Story, and
// the legal pages). Not rendered inside the authenticated app shell
// (/create, /dashboard, /get-credits), which uses a fixed sidebar/bottom-tab
// nav on mobile; that placement is a separate follow-up.
const SiteFooter = () => (
  <footer className="lp-footer">
    <span className="lp-footer-logo">ZYNACULAR</span>
    <div className="lp-footer-center">
      <Link to="/story" className="lp-footer-link">Our Story</Link>
      <Link to="/support" className="lp-footer-link">Support</Link>
      <Link to="/privacy" className="lp-footer-link">Privacy Policy</Link>
      <Link to="/terms" className="lp-footer-link">Terms of Service</Link>
      <Link to="/contact" className="lp-footer-link">Contact</Link>
    </div>
    <span className="lp-footer-copy">Patent pending. © 2026 Zynacular. All rights reserved.</span>
  </footer>
);

export default SiteFooter;
